import H1 from '@components/text/h1.view';
import H2 from '@components/text/h2.view';
import H3 from '@components/text/h3.view';
import H4 from '@components/text/h4.view';
import H5 from '@components/text/h5.view';
import H6 from '@components/text/h6.view';

export type { HeadingProps } from './types/props';

export { H1 };
export { H2 };
export { H3 };
export { H4 };
export { H5 };
export { H6 };
